import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import AppContent from "./AppContent";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {persistor, store} from "./redux";
import axios from "axios";
import {BrowserRouter} from "react-router-dom";
import {ApplicationContextProvider} from "./context/ApplicationContextProvider";
import {ThemeProvider} from "@emotion/react";
import {theme} from "./assets/colors/themes";
import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById("root"));

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <HelmetProvider>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        <ApplicationContextProvider>
                            <AppContent />
                        </ApplicationContextProvider>
                    </BrowserRouter>
                </ThemeProvider>
            </HelmetProvider>
        </PersistGate>
    </Provider>
);
